import "./empty_view.scss";

import { PureComponent } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import { Feature } from "graphql_globals";
import { DOCUMENT_UPLOADER_ERROR_MSG } from "constants/aria-describedby";
import Icon from "common/core/icon";
import ActionButton from "common/core/action_button";
import { sandboxEnabled } from "config/environment/sandbox";

import { getPreferredFileMessage } from "./document_item_util";

function clickText(text) {
  return <span className="DocumentUploaderEmptyView--Content--ClickUpload">{text}</span>;
}

/**
 * The view of the document uploader when there are no documents yet to manage.
 */
export default class DocumentUploaderEmptyView extends PureComponent {
  handleDragOver = (event) => {
    event.dataTransfer.dropEffect = "copy";
  };

  handleDrop = (event) => {
    const files = Array.from(event.dataTransfer.files);
    this.props.onDropFiles(files);
  };

  render() {
    const {
      supportedFileTypes,
      onActionClick,
      organization: { featureList },
      allowAddByTemplateMessage,
      showAcceptedDocuments,
    } = this.props;
    const isSandbox = sandboxEnabled();
    const showTemplateMessage =
      allowAddByTemplateMessage &&
      featureList.includes(Feature.DOCUMENT_TEMPLATES) &&
      !sandboxEnabled;
    const clickMessage = isSandbox ? (
      <FormattedMessage
        id="56c30a95-88ae-4195-9dc8-7d78b8066104"
        defaultMessage="Click to Select A Template"
      >
        {clickText}
      </FormattedMessage>
    ) : (
      <FormattedMessage
        id="56c30a95-88ae-4395-9dc8-7d78b8066104"
        defaultMessage="Click to Upload A Document"
      >
        {clickText}
      </FormattedMessage>
    );
    const preferredFileMessage = getPreferredFileMessage(supportedFileTypes, showAcceptedDocuments);

    return (
      <div className="DocumentUploaderEmptyView">
        {!isSandbox && (
          <div className="DocumentUploaderEmptyView--Header">
            <p id="pdf-files-preferred">{preferredFileMessage}</p>
          </div>
        )}
        <div className="DocumentUploaderEmptyView--Content">
          <ActionButton
            aria-describedby={`pdf-files-preferred ${DOCUMENT_UPLOADER_ERROR_MSG}`}
            color="dark"
            className="DocumentUploaderEmptyView--Content--Action"
            onClick={onActionClick}
            onDrop={this.handleDrop}
            onDragOver={this.handleDragOver}
            automationId="document-uploader-add-documents"
          >
            <Icon name="add-document" className="DocumentUploaderEmptyView--Content--Icon" />
            {!sandboxEnabled && (
              <FormattedMessage
                id="590d67dc-d24f-4505-a73b-1a60dd7a3c92"
                defaultMessage="Drag and Drop or"
              />
            )}
            {clickMessage}
            {showTemplateMessage && (
              <FormattedMessage
                id="22215627-af2c-46a1-8d97-fd287e44d243"
                defaultMessage="or Add A Template"
              >
                {clickText}
              </FormattedMessage>
            )}
          </ActionButton>
        </div>
      </div>
    );
  }
}

DocumentUploaderEmptyView.propTypes = {
  supportedFileTypes: PropTypes.array.isRequired,
  onActionClick: PropTypes.func.isRequired,
  /** Called when user drag/drops uploads and an array of files is passed */
  onDropFiles: PropTypes.func.isRequired,
  organization: PropTypes.object,
  allowAddByTemplateMessage: PropTypes.bool,
  showAcceptedDocuments: PropTypes.bool,
};

DocumentUploaderEmptyView.defaultProps = {
  allowAddByTemplateMessage: true,
  showAcceptedDocuments: true,
};
